import { type FC } from "react";
import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";

interface Props {
  allSelected: boolean;
  someSelected: boolean;
  disabled: boolean;
  onToggleAll: () => void;
}

const ClientsTableHead: FC<Props> = ({ allSelected, someSelected, disabled, onToggleAll }) => (
  <TableHead>
    <TableRow sx={{ bgcolor: "rgba(0,0,0,0.02)", "& .MuiTableCell-head": { whiteSpace: "nowrap" } }}>
      <TableCell padding="checkbox">
        <Checkbox
          indeterminate={someSelected && !allSelected}
          checked={allSelected}
          onChange={onToggleAll}
          disabled={disabled}
        />
      </TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 220 }}>Klient</TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 220, whiteSpace: "nowrap" }}>Telefon / E-mail</TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>Status</TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 280 }}>Osoba kontaktowa</TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 120, fontSize: "65%" }} title="Ostatnia spotkanie i notatke">
        spotkanie
        <br />
        Przezmorze
        <br />
        TravelPay
      </TableCell>
      <TableCell sx={{ fontWeight: 700, minWidth: 120 }} align="right">
        Akcje
      </TableCell>
    </TableRow>
  </TableHead>
);

export default ClientsTableHead;
